import { Column, Columns, PageBlock } from 'braid-design-system';
import { memo } from 'react';

import { useZoneFeatures } from 'src/config/appConfig';
import type { ZoneFeatures } from 'src/config/types';

import Campaign, { type CampaignProps } from './Campaign/Campaign';
import type { MobileCampaignProps } from './Campaign/MobileCampaign';
import GenericAsiaBanner from './GenericAsiaBanner/GenericAsiaBanner';
import { TarzanCampaignBanner } from './TarzanCampaignBanner/TarzanCampaignBanner';

export type BannerProps =
  | Omit<CampaignProps, 'type'>
  | Omit<MobileCampaignProps, 'type'>;

const HomePageBanner = () => {
  const { HOMEPAGE_BANNER_TYPE: homepageBannerType } = useZoneFeatures();

  const homepageBannerContent = getHomePageBannerContent(homepageBannerType);

  return <PageBlock>{homepageBannerContent}</PageBlock>;
};

export const MultiCampaign = (props: [BannerProps, BannerProps]) => (
  <Columns collapseBelow="tablet" space={{ mobile: 'small', tablet: 'large' }}>
    <Column>
      <Campaign {...props[0]} type="multi-campaign" />
    </Column>
    <Column>
      <Campaign {...props[1]} type="multi-campaign" />
    </Column>
  </Columns>
);

const getHomePageBannerContent = (
  homepageBannerType: ZoneFeatures['HOMEPAGE_BANNER_TYPE'],
) => {
  switch (homepageBannerType) {
    case 'multiple-asia':
      return <GenericAsiaBanner />;
    case 'single':
      return <TarzanCampaignBanner />;
  }
};

export default memo(HomePageBanner);
